import { useViewModel } from './useViewModel'
import { AlertMessage } from '@/app/components'
import { Props } from './useViewModel'

export default function UtilityProgramDashboardAlert(props: Props) {
  const { dashboardAlertContent } = useViewModel(props)

  return (
    <AlertMessage
      variant="info"
      rawHtmlText={dashboardAlertContent}
      show={Boolean(dashboardAlertContent)}
    />
  )
}
